import appNavigationNames, { TabNavigationParamList } from '../../../utils/appNavigationNames';
import { getIntl } from '../../../utils/intl';
import AccountNavigation from '../AccountNavigation';
import ActivityNavigation from '../ActivityNavigation';
import NotesNavigation from '../NotesNavigation';
import ProfilesNavigation from '../ProfilesNavigation';
import { IconName } from '../../v2BaseComponents/Icon';
import ResourcesNavigation from '../ResourcesNavigation';
import OrganizationNavigation from '../OrganizationNavigation';

const intl = getIntl('MainAppNavigation-side-drawer', {
    activity: 'Activity',
    notes: 'My Notes',
    myAccount: 'My Account',
    profiles: 'Profiles',
    clients: 'Clients',
    resources: 'Resources',
});

const bottomTabLabels = getIntl('MainAppNavigation-bottom-tab', {
    activity: 'Activity',
    notes: 'My Notes',
    myAccount: 'Account',
    profiles: 'Profiles',
    clients: 'Clients',
    resources: 'Resources',
});

export type TabName = keyof TabNavigationParamList;

export type TabConfig = {
    name: TabName;
    display: string;
    component: () => React.JSX.Element;
    iconName: IconName;
    tabRootScreen: string;
    bottomTabLabel: string;
    omitFromSideNav?: boolean;
};

const activityTabConfig: TabConfig = {
    name: appNavigationNames.tabs.activity,
    display: intl('activity'),
    component: ActivityNavigation as any,
    iconName: 'Activity',
    tabRootScreen: appNavigationNames.activity.root,
    bottomTabLabel: bottomTabLabels('activity'),
};

const notesTabConfig: TabConfig = {
    name: appNavigationNames.tabs.notes,
    display: intl('notes'),
    component: NotesNavigation as any,
    iconName: 'Edit2',
    tabRootScreen: appNavigationNames.notes.root,
    bottomTabLabel: bottomTabLabels('notes'),
};

const profilesTabConfig: TabConfig = {
    name: appNavigationNames.tabs.profiles,
    display: intl('profiles'),
    component: ProfilesNavigation as any,
    iconName: 'User',
    tabRootScreen: appNavigationNames.profiles.root,
    bottomTabLabel: bottomTabLabels('profiles'),
};

const clientsTabConfig: TabConfig = {
    ...profilesTabConfig,
    name: appNavigationNames.tabs.clients,
    display: intl('clients'),
    iconName: 'Users',
    bottomTabLabel: bottomTabLabels('clients'),
};

const accountTabConfig: TabConfig = {
    name: appNavigationNames.tabs.account,
    display: intl('myAccount'),
    component: AccountNavigation as any,
    iconName: 'Settings',
    tabRootScreen: appNavigationNames.account.root,
    bottomTabLabel: bottomTabLabels('myAccount'),
};

const resourcesTabConfig: TabConfig = {
    name: appNavigationNames.tabs.resources,
    display: intl('resources'),
    component: ResourcesNavigation as any,
    iconName: 'Library',
    tabRootScreen: appNavigationNames.resources.root,
    bottomTabLabel: bottomTabLabels('resources'),
};

const organizationTabConfig: TabConfig = {
    name: appNavigationNames.tabs.organization,
    display: 'Organization',
    component: OrganizationNavigation as any,
    iconName: 'OfficeBuilding',
    tabRootScreen: appNavigationNames.organization.root,
    bottomTabLabel: 'Organization',
    omitFromSideNav: true,
};

export const consumerAppMobileTabConfig: TabConfig[] = [
    activityTabConfig,
    notesTabConfig,
    profilesTabConfig,
    accountTabConfig,
];

export const consumerAppDesktopTabConfig: TabConfig[] = [
    profilesTabConfig,
    activityTabConfig,
    notesTabConfig,
    accountTabConfig,
];

export const professionalAppTabConfig: TabConfig[] = [
    clientsTabConfig,
    resourcesTabConfig,
    organizationTabConfig,
    accountTabConfig,
];
